import React from "react";
import { Container } from "reactstrap";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <div className="text-sm-end d-none d-sm-block">
            {new Date().getFullYear()} © Grupoda2
          </div>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
